import React, {useState} from 'react'
import { useCallback } from 'react';
import { useEffect } from 'react';
import Modal from 'react-modal';
import ModalContent from './ModalContent';





let left = '0'
let right = '0'
let widthh = '170%'
let heightt = '100%'
if (window.screen.width>1200) {
    left = '50%'
    right = 720*(window.screen.width/1000) + 'px'
    widthh = 2000*(window.screen.width/1000) + 'px'
    heightt = 1600*(window.screen.width/1000) + 'px'
}


Modal.setAppElement('#root');

const Projects = (props) => {
    const [biggen, setBiggen] = useState(false);
    const [change, setChange] = useState(props.change);
    const [param, setParam] = useState(0)
    const [lightbulbOpacity, setLightbulbOpacity] = useState(0)

    const styles = { height: heightt, textAlign:'center', position: 'relative', left: left}
    const styles2 = { height: heightt, textAlign:'center', position: 'relative', right: right}
    const projectStyles = {fill: '#FFFE98', overflow:'hidden'}






    let backGroundArr = [
        [[-800, 0]],
        [[-800, 3200]],
        [[2400, 3200]],
        [[2400, 0]]
    ]

    let backGround = ''





    let backGround2Arr = [
        [[-800, 500]],
        [[-800, 2000]],
        [[-800, 2000], [300, 2600], [1000, 2200]],
        [[1000, 2200], [1500, 1900], [2400, 2500]],
        [[2400, 2500]],
        [[2400, 300]],
        [[1900, 300]],
        [[1, 1], [0, 1], [1000, 300], [0]],
        [[1, 1], [0, 0], [400, 300], [0]],
        [[400, 500]]
    ]

    let backGround2 = ''




    let backGround3Arr = [
        [[-800, 500]],
        [[-800, 1700]],
        [[-800, 1700], [300, 2300], [1000, 1900]],
        [[1000, 1900], [1500, 1600], [2400, 2200]],
        [[2400, 2200]],
        [[2400, 300]],
        [[1900, 300]],
        [[1, 1], [0, 1], [1000, 300], [0]],
        [[1, 1], [0, 0], [400, 300], [0]],
        [[400, 500]]
    ]

    let backGround3 = ''



    let backGround4Arr = [
        [[-800, 800]],
        [[-800, 1700]],
        [[-800, 1700], [300, 2300], [1000, 1900]],
        [[1000, 1900], [1500, 1600], [2400, 2200]],
        [[2400, 2200]],
        [[2400, 600]],
        [[1900, 600]],
        [[545, 560], [0, 1], [900, 300], [0]],
        [[1, 1], [0, 0], [500, 300], [0]],
        [[500, 800]]
    ]

    let backGround4 = ''








    const hoverText = (state) => {
        if (state === false) {
            return 'yellow'
        } else {
            return 'red'
        }
        
    }


    

    const animate = useCallback(() => {

        if (!biggen) {


            let h = param
            var increment = setInterval(() => {
                
                if (h >= 1.1) {
                    clearInterval(increment)
                } else if (h === 1 ) {
                    h = h + 0.1
                    setParam(h)
                } else {
                    h = h + 0.2
                    setParam(h)
                    setLightbulbOpacity(h)
                }
                    
                
            }, 3)

            hoverText(biggen)

        } else {
            setBiggen(false)
            setParam(0)
            hoverText(biggen)
        }
    }, [biggen, param])


    useEffect(() => {


        setChange(props.change)
        if (change==='true') {
            animate()
        }
    }, [props.change, change, animate])












    let wFace2 = 170
    let hFace2 = -700

    
    hFace2 = (1-param)*(-500) + param*900

    let faceBlock2Arr = [[[370 + wFace2, 1500 + hFace2]], 
    [[700 + wFace2, 1500 + hFace2]], 
    [[700 + wFace2, 1700 + hFace2]],
    [[670 + wFace2, 1980 + hFace2]],
    [[340 + wFace2, 1980 + hFace2]],
    [[330 + wFace2, 1850 + hFace2]],
    [[260 + wFace2, 1790 + hFace2]],
    [[240 + wFace2, 1560 + hFace2]],
    [[370 + wFace2, 1560 + hFace2]]]

    let faceBlock2 = ''


    



    let eyesArr = [[[450 + wFace2, 1805 + hFace2]], 
    [[450 + wFace2, 1805 + hFace2], [420 + wFace2, 1880 + hFace2], [460 + wFace2, 1840 + hFace2]],
    [[460 + wFace2, 1840 + hFace2], [510 + wFace2, 1800 + hFace2], [490 + wFace2, 1780 + hFace2]],
    [[490 + wFace2, 1780 + hFace2], [470 + wFace2, 1765 + hFace2], [450 + wFace2, 1805 + hFace2]],
    [],
    [[350 + wFace2, 1805 + hFace2]], 
    [[350 + wFace2, 1805 + hFace2], [380 + wFace2, 1880 + hFace2], [340 + wFace2, 1840 + hFace2]],
    [[340 + wFace2, 1840 + hFace2], [290 + wFace2, 1800 + hFace2], [310 + wFace2, 1780 + hFace2]],
    [[310 + wFace2, 1780 + hFace2], [330 + wFace2, 1765 + hFace2], [350 + wFace2, 1805 + hFace2]]
    ]

    let eyes = ''



    let pupilsArr = [
    [[520, 1820 + hFace2]],
    [[1, 1], [1, 0], [500, 1820 + hFace2], [0]],
    [],
    [[520, 1820 + hFace2]],
    [[1, 1], [0, 1], [500, 1820 + hFace2], [0]],
    [],
    [[640, 1820 + hFace2]],
    [[1, 1], [1, 0], [620, 1820 + hFace2], [0]],
    [],
    [[640, 1820 + hFace2]],
    [[1, 1], [0, 1], [620, 1820 + hFace2], [0]]
    ]

    let pupils = ''



    let mouthArr = [

    [[610, 1920 + hFace2]],
    [[30, 20], [1, 0], [540, 1920 + hFace2], [0]],
    [],
    [[610, 1920 + hFace2]],
    [[30, 20], [0, 1], [540, 1920 + hFace2], [0]]
    ]

    let mouth = ''










    let screwArr = [[[440 + wFace2, 1550 + hFace2]], 
    [[440 + wFace2, 1360 + hFace2]],
    [[620 + wFace2, 1360 + hFace2]],
    [[620 + wFace2, 1550 + hFace2]]]

    let screw = ''












    let lightbulbArr = [[[450 + wFace2, 1380 + hFace2]],
    [[450 + wFace2, 1380 + hFace2], [460 + wFace2, 1300 + hFace2], [400 + wFace2, 1200 + hFace2]], 
    [[400 + wFace2, 1200 + hFace2], [330 + wFace2, 1100 + hFace2], [330 + wFace2, 1100 + hFace2]],
    [[330 + wFace2, 1100 + hFace2], [295 + wFace2, 1050 + hFace2], [300 + wFace2, 1000 + hFace2]],
    [[300 + wFace2, 1000 + hFace2], [300 + wFace2, 950 + hFace2], [330 + wFace2, 900 + hFace2]],
    [[330 + wFace2, 900 + hFace2], [355 + wFace2, 865 + hFace2], [400 + wFace2, 850 + hFace2]],
    [[400 + wFace2, 850 + hFace2], [470 + wFace2, 830 + hFace2], [530 + wFace2, 830 + hFace2]],
    [[530 + wFace2, 830 + hFace2]]]

    let lightbulbArr2 = [[[450 + wFace2, 1380 + hFace2]],
    [[450 + wFace2, 1380 + hFace2], [460 + wFace2, 1300 + hFace2], [400 + wFace2, 1200 + hFace2]], 
    [[400 + wFace2, 1200 + hFace2], [330 + wFace2, 1100 + hFace2], [190 + wFace2, 1040 + hFace2]],
    [[190 + wFace2, 1040 + hFace2], [10 + wFace2, 950 + hFace2], [0 + wFace2, 600 + hFace2]],
    [[0 + wFace2, 600 + hFace2], [-20 + wFace2, 330 + hFace2], [19 + wFace2, 260 + hFace2]],
    [[19 + wFace2, 260 + hFace2], [100 + wFace2, 100 + hFace2], [400 + wFace2, 50 + hFace2]],
    [[400 + wFace2, 50 + hFace2], [470 + wFace2, 40 + hFace2], [530 + wFace2, 40 + hFace2]],
    [[530 + wFace2, 40 + hFace2]]]

    let lightbulb = ''


    let mid = 530 +  wFace2
    let bottom = lightbulbArr2[0][0][1]
    let l = lightbulbArr.length


    for (let j=0; j<=l-1; j++) {
        if (j>=0) {
            if (lightbulbArr[j].length === 1) {
                lightbulbArr[j][0][0] = (1-param)*lightbulbArr[j][0][0] + param*lightbulbArr2[j][0][0]
                lightbulbArr[j][0][1] = (1-param)*lightbulbArr[j][0][1] + param*((lightbulbArr2[j][0][1] - bottom)*1.5 + bottom)
            } else if (lightbulbArr[j].length === 3) {
                lightbulbArr[j][0][0] = (1-param)*lightbulbArr[j][0][0] + param*lightbulbArr2[j][0][0]
                lightbulbArr[j][0][1] = (1-param)*lightbulbArr[j][0][1] + param*((lightbulbArr2[j][0][1] - bottom)*1.5 + bottom)
                lightbulbArr[j][1][0] = (1-param)*lightbulbArr[j][1][0] + param*lightbulbArr2[j][1][0]
                lightbulbArr[j][1][1] = (1-param)*lightbulbArr[j][1][1] + param*((lightbulbArr2[j][1][1] - bottom)*1.5 + bottom)
                lightbulbArr[j][2][0] = (1-param)*lightbulbArr[j][2][0] + param*lightbulbArr2[j][2][0]
                lightbulbArr[j][2][1] = (1-param)*lightbulbArr[j][2][1] + param*((lightbulbArr2[j][2][1] - bottom)*1.5 + bottom)
            } else if (lightbulbArr[j].length === 4) {
                lightbulbArr[j][2][0] = (1-param)*lightbulbArr[j][2][0] + param*lightbulbArr2[j][2][0]
                lightbulbArr[j][2][1] = (1-param)*lightbulbArr[j][2][1] + param*((lightbulbArr2[j][2][1] - bottom)*1.5 + bottom)
            }
        }
    }

    for (let i=l-1; i>-1; i--) {
        if (lightbulbArr[i].length === 1) {
            lightbulbArr.push([[2*mid - lightbulbArr[i][0][0], lightbulbArr[i][0][1]]])
        } else if (lightbulbArr[i].length === 3) {
            lightbulbArr.push([[2*mid - lightbulbArr[i][2][0], lightbulbArr[i][2][1]],   
                [2*mid - lightbulbArr[i][1][0], lightbulbArr[i][1][1]],
                [2*mid - lightbulbArr[i][0][0], lightbulbArr[i][0][1]]])
        }
    }








    let lightbulbLightArr = []

    let lightbulbLight = ''





    let lightbulbFixX = mid
    let lightbulbFixY = lightbulbArr[0][0][1]
    for (let j=0; j<lightbulbArr.length; j++) {
        if (j>=0) {

            let item
            if (lightbulbArr[j].length === 0) {
                item = []
            } else if (lightbulbArr[j].length === 1) {
                let aX = (lightbulbArr[j][0][0]-lightbulbFixX)*1.1 + lightbulbFixX
                let aY = (lightbulbArr[j][0][1]-lightbulbFixY)*0.03 + lightbulbArr[j][0][1]
                item =[[aX, aY]]
            } else if (lightbulbArr[j].length === 3) {
                let aX = (lightbulbArr[j][0][0]-lightbulbFixX)*1.1 + lightbulbFixX
                let aY = (lightbulbArr[j][0][1]-lightbulbFixY)*0.03 + lightbulbArr[j][0][1]
                let bX = (lightbulbArr[j][1][0]-lightbulbFixX)*1.1 + lightbulbFixX
                let bY = (lightbulbArr[j][1][1]-lightbulbFixY)*0.03 + lightbulbArr[j][1][1]
                let cX = (lightbulbArr[j][2][0]-lightbulbFixX)*1.1 + lightbulbFixX
                let cY = (lightbulbArr[j][2][1]-lightbulbFixY)*0.03 + lightbulbArr[j][2][1]
                item =[[aX, aY], [bX, bY], [cX, cY]]
            } else if (lightbulbArr[j].length === 4) {
                let aX = lightbulbArr[j][0][0]
                let aY = lightbulbArr[j][0][1]
                let bX = lightbulbArr[j][1][0]
                let bY = lightbulbArr[j][1][1]
                let cX = (lightbulbArr[j][2][0]-lightbulbFixX)*1.1 + lightbulbFixX
                let cY = (lightbulbArr[j][2][1]-lightbulbFixY)*0.03 + lightbulbArr[j][2][1]
                let dX = lightbulbArr[j][3][0]
                let dY = lightbulbArr[j][3][1]
                item =[[aX, aY], [bX, bY], [cX, cY], [dX, dY]]
            }

            lightbulbLightArr.push(item)
        }
    }




    let width = (lightbulbArr[12][0][0] - lightbulbArr[4][0][0])/1.2
    let wDiff = (lightbulbArr[12][0][0] - lightbulbArr[4][0][0]) - width
    let wMin = lightbulbArr[4][0][0] + wDiff
    let wMid = (width)/2 + wMin - wDiff/2


    let height = (lightbulbArr[0][0][1] - lightbulbArr[7][0][1])*0.95
    let hDiff = height - (lightbulbArr[0][0][1] - lightbulbArr[7][0][1])
    let hMax = lightbulbArr[0][0][1]
    let hMin = lightbulbArr[7][0][1] - hDiff



    lightbulbLightArr.push([[610 + wFace2, hMax]])
    lightbulbLightArr.push([[616 + wFace2, hMax], [616 + wFace2 + width*(-0.04), hMax - height*0.2], [616 + wFace2 + wMid*0.5, hMax - height*0.35]])
    lightbulbLightArr.push([[616 + wFace2 + wMid*0.5, hMax - height*0.35], [616 + wFace2 + width*(-0.04), hMax - height*0.2], [616 + wFace2 + wMid*0.2, hMax - height*0.7]])
    lightbulbLightArr.push([[616 + wFace2 + wMid*0.5, hMax - height*0.7], [616 + wFace2 + width*(-0.04), hMax - height*0.6], [616 + wFace2 + wMid*(-0.2), hMax - height*0.63]])


    lightbulbLightArr.push([[616 + wFace2 + wMid*(-0.1), hMax - height*0.65],   [616 + wFace2 + wMid*(-0.6), hMax - height*0.70],   [wMid - width*0.45, hMin + height*0.50]])
    lightbulbLightArr.push([[616 + wFace2 + wMid*(-0.1), hMax - height*0.65],   [616 + wFace2 + wMid*(-0.6), hMax - height*0.70],   [wMid - width*0.11, hMin + height*0.80]])
    lightbulbLightArr.push([[wMid - width*0.11, hMin + height*0.80],   [616 + wFace2 + wMid*(-0.1), hMax - height*0.10],   [448 + wFace2, hMax]])

    lightbulbLightArr.push([[448 + wFace2, hMax]])



    





    let lightbulb2LightArr = []

    let lightbulb2Light = ''


    let lightbulb4LightArr = []

    let lightbulb4Light = ''

    for (let j=0; j<lightbulbArr.length; j++) {
        if (j>=0) {

            let item
            if (lightbulbArr[j].length === 0) {
                item = []
            } else if (lightbulbArr[j].length === 1) {
                let aX = (lightbulbArr[j][0][0]-lightbulbFixX) + lightbulbFixX
                let aY = (lightbulbArr[j][0][1]-lightbulbFixY) + lightbulbFixY
                item =[[aX, aY]]
            } else if (lightbulbArr[j].length === 3) {
                let aX = (lightbulbArr[j][0][0]-lightbulbFixX) + lightbulbFixX
                let aY = (lightbulbArr[j][0][1]-lightbulbFixY) + lightbulbFixY
                let bX = (lightbulbArr[j][1][0]-lightbulbFixX) + lightbulbFixX
                let bY = (lightbulbArr[j][1][1]-lightbulbFixY) + lightbulbFixY
                let cX = (lightbulbArr[j][2][0]-lightbulbFixX) + lightbulbFixX
                let cY = (lightbulbArr[j][2][1]-lightbulbFixY) + lightbulbFixY
                item =[[aX, aY], [bX, bY], [cX, cY]]
            } else if (lightbulbArr[j].length === 4) {
                let aX = lightbulbArr[j][0][0]
                let aY = lightbulbArr[j][0][1]
                let bX = lightbulbArr[j][1][0]
                let bY = lightbulbArr[j][1][1]
                let cX = (lightbulbArr[j][2][0]-lightbulbFixX) + lightbulbFixX
                let cY = (lightbulbArr[j][2][1]-lightbulbFixY) + lightbulbFixY
                let dX = lightbulbArr[j][3][0]
                let dY = lightbulbArr[j][3][1]
                item =[[aX, aY], [bX, bY], [cX, cY], [dX, dY]]
            }

            lightbulb2LightArr.push(item)

            if (j<=lightbulbArr.length/2 + 3 && j>2) {
                lightbulb4LightArr.push(item)
            }
        }
    }







    let lightbulb3LightArr = [[[40 + wFace2, -880 + hFace2]],
    [[40 + wFace2, -880 + hFace2], [530 + wFace2, -1150 + hFace2], [1020 + wFace2, -880 + hFace2]], // 
    [[1020 + wFace2, -880 + hFace2], [1320 + wFace2, -700 + hFace2], [1330 + wFace2, -350 + hFace2]], // 490, 790, 800
    [[1330 + wFace2, -350 + hFace2], [1340 + wFace2, -100 + hFace2], [1300 + wFace2, 200 + hFace2]], // 800, 810, 770
    [[1300 + wFace2, 200 + hFace2], [1250 + wFace2, 570 + hFace2], [1150 + wFace2, 705 + hFace2]], // 770, 720, 620
    [[1150 + wFace2, 705 + hFace2], [1050 + wFace2, 850 + hFace2], [915 + wFace2, 915 + hFace2]], // 620, 520, 385
    [[915 + wFace2, 915 + hFace2], [700 + wFace2, 1020 + hFace2], [640 + wFace2, 1280 + hFace2]], // 385, 170, 110
    [[640 + wFace2, 1280 + hFace2], [630 + wFace2, 1325 + hFace2], [625 + wFace2, 1380 + hFace2]],
    [[625 + wFace2, 1380 + hFace2]],
    [[435 + wFace2, 1380 + hFace2]],
    [[435 + wFace2, 1380 + hFace2], [430 + wFace2, 1325 + hFace2], [420 + wFace2, 1280 + hFace2]], //
    [[420 + wFace2, 1280 + hFace2], [360 + wFace2, 1020 + hFace2], [145 + wFace2, 915 + hFace2]], //
    [[145 + wFace2, 915 + hFace2], [10 + wFace2, 850 + hFace2], [-90 + wFace2, 705 + hFace2]], //
    [[-90 + wFace2, 705 + hFace2], [-190 + wFace2, 570 + hFace2], [-240 + wFace2, 200 + hFace2]], //
    [[-240 + wFace2, 200 + hFace2], [-280 + wFace2, -100 + hFace2], [-270 + wFace2, -350 + hFace2]],//
    [[-270 + wFace2, -350 + hFace2], [-260 + wFace2, -700 + hFace2], [40 + wFace2, -880 + hFace2]], //
    [[-200 + wFace2, 0 + hFace2]]
    ]

    let lightbulb3Light = ''












    let filamentArr = [
        [[510, 1550 + hFace2]],
        [[510, 1550 + hFace2], [510, 1550 + hFace2], [505, 1225 + hFace2]],
        [[505, 1225 + hFace2], [505, 1205 + hFace2], [490, 1195 + hFace2]],
        [[490, 1195 + hFace2], [500, 1110 + hFace2], [500, 1110 + hFace2]], //
        [[500, 1110 + hFace2], [400, 1080 + hFace2], [395, 990 + hFace2]],
        [[395, 990 + hFace2]],
        [],
        [[650, 1000 + hFace2], [650, 1080 + hFace2], [650, 1080 + hFace2]],
        [[650, 1080 + hFace2], [650, 1085 + hFace2], [650, 1080 + hFace2]],
        [[650, 1080 + hFace2], [665, 1085 + hFace2], [660, 1145 + hFace2]],
        [[660, 1145 + hFace2], [650, 1195 + hFace2], [600, 1200 + hFace2]],
        
        [[660, 1145 + hFace2], [600, 1200 + hFace2], [600, 1200 + hFace2]],

        [[600, 1200 + hFace2], [500, 1200 + hFace2], [550, 1550 + hFace2]],
        [[550, 1550 + hFace2]],


        [],
        [[490, 1193 + hFace2]],
        [[1, 1], [1, 0], [475, 1193 + hFace2], [0]],
        [],
        [[490, 1193 + hFace2]],
        [[1, 1], [0, 1], [475, 1193 + hFace2], [0]],
        [],
        [[500, 1110 + hFace2]],
        [[1, 1], [1, 0], [510, 1110 + hFace2], [0]],
        [],
        [[500, 1110 + hFace2]],
        [[1, 1], [0, 1], [510, 1110 + hFace2], [0]],
        [],
        [[650, 1080 + hFace2]],
        [[1, 1], [1, 0], [640, 1080 + hFace2], [0]],
        [],
        [[650, 1080 + hFace2]],
        [[1, 1], [0, 1], [640, 1080 + hFace2], [0]]
    ]


    let filamentArr2 = [
        [[510, 1550 + hFace2]],
        [[510, 1550 + hFace2], [510, 1550 + hFace2], [505, 1200 + hFace2]],
        [[505, 1200 + hFace2], [505, 1000 + hFace2], [490, 860 + hFace2]],
        [[490, 860 + hFace2], [500, 800 + hFace2], [500, 660 + hFace2]], //
        [[500, 660 + hFace2], [240, 650 + hFace2], [280, 40 + hFace2]],
        [[280, 40 + hFace2]],
        [],
        [[850, 40 + hFace2], [850, 40 + hFace2], [850, 40 + hFace2]],
        [[850, 0 + hFace2], [900, 200 + hFace2], [840, 300 + hFace2]],
        [[840, 300 + hFace2], [920, 340 + hFace2], [920, 515 + hFace2]],
        [[920, 515 + hFace2], [920, 730 + hFace2], [820, 830 + hFace2]],

        [[820, 830 + hFace2], [780, 870 + hFace2], [630, 880 + hFace2]],

        [[630, 880 + hFace2], [530, 900 + hFace2], [550, 1500 + hFace2]],
        [[550, 1500 + hFace2]],


        [],
        [[490, 860 + hFace2]],
        [[10,  10], [1, 0], [100, 860 + hFace2], [0]],
        [],
        [[490, 860 + hFace2]],
        [[10,  10], [0, 0], [100, 860 + hFace2], [0]],
        [],

        [[485, 600 + hFace2]],
        [[10,  10], [1, 0], [875, 600 + hFace2], [0]],
        [],
        [[485, 600 + hFace2]],
        [[10,  10], [0, 0], [875, 600 + hFace2], [0]],
        [],

        [[750, 250 + hFace2]],
        [[10,  10], [0, 0], [360, 250 + hFace2], [0]],
        [],
        [[750, 250 + hFace2]],
        [[10,  10], [0, 0], [360, 250 + hFace2], [0]]
    ]




    l = filamentArr.length

    for (let j=0; j<=l-1; j++) {

        
        if (j>=0) {
            if (filamentArr[j].length === 1) {
                filamentArr[j][0][0] = (1-param)*filamentArr[j][0][0] + param*((filamentArr2[j][0][0])) + wFace2
                filamentArr[j][0][1] = (1-param)*filamentArr[j][0][1] + param*((filamentArr2[j][0][1] - bottom)*1.3 + bottom) -50
            } else if (filamentArr[j].length === 3) {
                filamentArr[j][0][0] = (1-param)*filamentArr[j][0][0] + param*((filamentArr2[j][0][0])) + wFace2
                filamentArr[j][0][1] = (1-param)*filamentArr[j][0][1] + param*((filamentArr2[j][0][1] - bottom)*1.3 + bottom) -50
                filamentArr[j][1][0] = (1-param)*filamentArr[j][1][0] + param*((filamentArr2[j][1][0])) + wFace2
                filamentArr[j][1][1] = (1-param)*filamentArr[j][1][1] + param*((filamentArr2[j][1][1] - bottom)*1.3 + bottom) -50
                filamentArr[j][2][0] = (1-param)*filamentArr[j][2][0] + param*((filamentArr2[j][2][0])) + wFace2
                filamentArr[j][2][1] = (1-param)*filamentArr[j][2][1] + param*((filamentArr2[j][2][1] - bottom)*1.3 + bottom) -50
            } else if (filamentArr[j].length === 4) {
                filamentArr[j][2][0] = (1-param)*filamentArr[j][2][0] + param*((filamentArr2[j][2][0])) + wFace2
                filamentArr[j][2][1] = (1-param)*filamentArr[j][2][1] + param*((filamentArr2[j][2][1] - bottom)*1.3 + bottom) -50
            }
        }
    }


    let filament = ''







    let filamentGlowArr = []

    let filamentGlow = ''


    for (let j=0; j<filamentArr.length; j++) {
        if (j>=0) {

            let item
            if (filamentArr[j].length === 0) {
                item = []
            } else if (filamentArr[j].length === 1) {
                let aX = (filamentArr[j][0][0])
                let aY = (filamentArr[j][0][1])
                item =[[aX, aY]]
            } else if (filamentArr[j].length === 3) {
                let aX = (filamentArr[j][0][0])
                let aY = (filamentArr[j][0][1])
                let bX = (filamentArr[j][1][0])
                let bY = (filamentArr[j][1][1])
                let cX = (filamentArr[j][2][0])
                let cY = (filamentArr[j][2][1])
                item =[[aX, aY], [bX, bY], [cX, cY]]
            } else if (filamentArr[j].length === 4) {
                let aX = filamentArr[j][0][0]
                let aY = filamentArr[j][0][1]
                let bX = filamentArr[j][1][0]
                let bY = filamentArr[j][1][1]
                let cX = (filamentArr[j][2][0])
                let cY = (filamentArr[j][2][1])
                let dX = filamentArr[j][3][0]
                let dY = filamentArr[j][3][1]
                item =[[aX, aY], [bX, bY], [cX, cY], [dX, dY]]
            }

            filamentGlowArr.push(item)

        }
    }





    



    let highlightsArr = [[[90 + wFace2, -470 + hFace2]],
    [[90 + wFace2, -470 + hFace2], [20 + wFace2, -300 + hFace2], [40 + wFace2, -80 + hFace2]],
    [[40 + wFace2, -80 + hFace2], [100 + wFace2, -110 + hFace2], [200 + wFace2, -100 + hFace2]],
    [[200 + wFace2, -100 + hFace2], [100 + wFace2, -260 + hFace2], [360 + wFace2, -590 + hFace2]],
    [[300 + wFace2, -590 + hFace2], [170 + wFace2, -540 + hFace2], [90 + wFace2, -470 + hFace2]]]

    // highlightsArr = [[[350 + wFace2, 960 + hFace2]],
    // [[350 + wFace2, 960 + hFace2], [300 + wFace2, 1000 + hFace2], [360 + wFace2, 1120 + hFace2]],
    // [[360 + wFace2, 1120 + hFace2], [360 + wFace2, 1080 + hFace2], [450 + wFace2, 1100 + hFace2]],
    // [[450 + wFace2, 1100 + hFace2], [430+ wFace2, 1000+ hFace2], [460 + wFace2, 950 + hFace2]],
    // [[400 + wFace2, 950 + hFace2], [370 + wFace2, 970+ hFace2], [350 + wFace2, 960 + hFace2]]]



    highlightsArr = [
        
    [[(350 + wFace2)*(1-param)*1.1 + (90 + wFace2)*(param*1.1),    (960 + hFace2)*(1-param)*1.1 + (-470 + hFace2)*(param*1.1)]],

    [[(350 + wFace2)*(1-param)*1.1 + (90 + wFace2)*(param*1.1),    (960 + hFace2)*(1-param)*1.1 + (-470 + hFace2)*(param*1.1)], 
        [(300 + wFace2)*(1-param)*1.1 + (20 + wFace2)*param*1.1,   (1000 + hFace2)*(1-param)*1.1 + (-300 + hFace2)*param*1.1],  
            [(360 + wFace2)*(1-param)*1.1 + (40 + wFace2)*param*1.1, (1120 + hFace2)*(1-param)*1.1 + (-80 + hFace2)*param*1.1]],

    [[(360 + wFace2)*(1-param)*1.1 + (40 + wFace2)*param*1.1, (1120 + hFace2)*(1-param)*1.1 + (-80 + hFace2)*param*1.1], 
        [(360 + wFace2)*(1-param)*1.1 + (100 + wFace2)*param*1.1, (1080 + hFace2)*(1-param)*1.1 + (-110 + hFace2)*param*1.1], 
            [(450 + wFace2)*(1-param)*1.1 + (200 + wFace2)*param*1.1, (1100 + hFace2)*(1-param)*1.1 + (-100 + hFace2)*param*1.1]],

    [[(450 + wFace2)*(1-param)*1.1 + (200 + wFace2)*param*1.1, (1100 + hFace2)*(1-param)*1.1 + (-100 + hFace2)*param*1.1], 
        [(430+ wFace2)*(1-param)*1.1 + (100 + wFace2)*param*1.1, (1000 + hFace2)*(1-param)*1.1 + (-260 + hFace2)*param*1.1], 
            [(460 + wFace2)*(1-param)*1.1 + (360 + wFace2)*param*1.1, (950 + hFace2)*(1-param)*1.1 + (-590 + hFace2)*param*1.1]],

    [[(400 + wFace2)*(1-param)*1.1  +  (300 + wFace2)*param*1.1, (950 + hFace2)*(1-param)*1.1 + (-590 + hFace2)*param*1.1], 
        [(370 + wFace2)*(1-param)*1.1 + (170 + wFace2)*param*1.1, (970 + hFace2)*(1-param)*1.1 + (-540 + hFace2)*param*1.1], 
            [(350 + wFace2)*(1-param)*1.1 + (90 + wFace2)*param*1.1, (960 + hFace2)*(1-param)*1.1 + (-470 + hFace2)*param*1.1]]
        
    ]


    let highlights = ''


















    let shapesArr = [
    [faceBlock2Arr, faceBlock2],    //0
    [screwArr, screw],              //1
    [lightbulbArr, lightbulb],      //2
    [filamentArr, filament],        //3
    [eyesArr, eyes],                //4
    [pupilsArr, pupils], 
    [mouthArr, mouth],
    [lightbulbLightArr, lightbulbLight],
    [lightbulb2LightArr, lightbulb2Light],
    [lightbulb3LightArr, lightbulb3Light],
    [lightbulb4LightArr, lightbulb4Light],
    [backGroundArr, backGround],            //11
    [backGround2Arr, backGround2],
    [filamentGlowArr, filamentGlow],
    [highlightsArr, highlights],
    [backGround3Arr, backGround3],          //15
    [backGround4Arr, backGround4]
    ]







    for (let j=0; j < shapesArr.length; j++) {
        for (let i=0; i < shapesArr[j][0].length; i++) {

            if (i === 0) {
                shapesArr[j][1] = shapesArr[j][1] + 'M' + shapesArr[j][0][0][0][0] + ' ' + shapesArr[j][0][0][0][1] + ' '
            } else {
                if (shapesArr[j][0][i].length === 0) {
                    shapesArr[j][1] = shapesArr[j][1] + 'M' + shapesArr[j][0][i + 1][0][0] + ' ' + shapesArr[j][0][i + 1][0][1] + ' '
                }
                else if(shapesArr[j][0][i].length === 1) {
                    shapesArr[j][1] = shapesArr[j][1] + 'L' + shapesArr[j][0][i][0][0] + ' ' + shapesArr[j][0][i][0][1] + ' '
                } else if (shapesArr[j][0][i].length === 3) {
                    shapesArr[j][1] = shapesArr[j][1] + ' Q' + shapesArr[j][0][i][1][0] + ' ' + shapesArr[j][0][i][1][1] + ' ' + shapesArr[j][0][i][2][0] + ' ' + shapesArr[j][0][i][2][1] + ' '
                } else if (shapesArr[j][0][i].length === 4) {
                    shapesArr[j][1] = shapesArr[j][1] + 'A' + shapesArr[j][0][i][0][0] + ' ' + shapesArr[j][0][i][0][1] + ' ' + shapesArr[j][0][i][3][0] + ' ' + shapesArr[j][0][i][1][0] + ' ' + shapesArr[j][0][i][1][1] + ' ' + shapesArr[j][0][i][2][0] + ' ' + shapesArr[j][0][i][2][1] + ' '
                }
            }

        }
        
    }

    shapesArr[0][1] = shapesArr[0][1] + 'Z'
    shapesArr[1][1] = shapesArr[1][1] + 'Z'
    shapesArr[4][1] = shapesArr[4][1] + 'Z'







    let centre1X = (filamentArr[15][0][0] - filamentArr[16][2][0])/2 + filamentArr[16][2][0]
    let centre1Y = filamentArr[15][0][1]
    let radius1 = Math.abs(Math.abs(filamentArr[15][0][0] - filamentArr[16][2][0])/2 - 30)*(param)

    let centre2X = (filamentArr[21][0][0] - filamentArr[22][2][0])/2 + filamentArr[22][2][0]
    let centre2Y = filamentArr[21][0][1]
    let radius2 = Math.abs(Math.abs(filamentArr[21][0][0] - filamentArr[22][2][0])/2 - 30)*(param)

    let centre3X = (filamentArr[27][0][0] - filamentArr[28][2][0])/2 + filamentArr[28][2][0]
    let centre3Y = filamentArr[27][0][1]
    let radius3 = Math.abs(Math.abs(filamentArr[27][0][0] - filamentArr[28][2][0])/2 - 30)*(param)



    let projectText = param*30 + ''




    const [txtX, setTxtX] = useState(filamentArr[5][0][0] + 90 - 140*(1 - param))
    // const [txtY, setTxtY] = useState(filamentArr[5][0][1])
    const txtY = filamentArr[5][0][1]
    const [textColor, setTextColor] = useState('#EEEAFC')
    const [textSize, setTextSize] = useState('90')
    const [modalIsOpen, setIsOpen] = React.useState(false)
    const [modelContent, setModelContent] = useState('')

    const textOn = () => {
        setTextColor('#FFF591')
        setTextSize('100')
        setTxtX(filamentArr[5][0][0] + 80 - 140*(1 - param))
    }

    const textOff = () => {
        setTextColor('#EEEAFC')
        setTextSize('90')
        setTxtX(filamentArr[5][0][0] + 90 - 140*(1 - param))
    }

    const handleClick = (str) => {
        setModelContent(str)
        if (modalIsOpen) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }

    let textStyles = {fill: textColor, fontSize: textSize, fontFamily: 'Montserrat Alternates, sans-serif', writable: 'true'}








    
    return (

        <div style={styles}>
            <div style={styles2}>

                        {/* <svg viewBox={'-600 0 2400 3200'} width={'1400px'} height={'2000px'}></svg> */}
                        <svg viewBox={'-250 0 3200 3200'} style={{overflow: 'hidden', fontSize: '0'}} width={widthh} height={heightt}>

                            
                            <path id={'backGroundArr'} d={shapesArr[11][1]} fill={'#343249'} stroke={'#343249'} strokeWidth={'2'}/>

                            <path id={'backGround2Arr'} d={shapesArr[12][1]} fill={'#090849'} stroke={'none'} strokeWidth={'2'}/>
                            <path id={'backGround3Arr'} d={shapesArr[15][1]} fill={'#2F2A44'} stroke={'none'} strokeWidth={'2'}/>
                            <path id={'backGround4Arr'} d={shapesArr[16][1]} fill={'#090849'} stroke={'none'} strokeWidth={'2'}/>

                            <path id={'backGround5'} d={"M-800 1200 L-800 2000  Q300 2600 1000 2200  Q1500 1900 2400 2500  L2400 2500    L2400 1300    A1 1 0 0 1 1360 1300   L 1360 1300   L 1300 1300 A1 1 0 0 1 800 1100   L 800 800 A1 1 0 0 0 650 800   L650 1200 "} fill={'#FF1616'} stroke={'#343249'} strokeWidth={'2'}/>
                            {/* <path id={'backGround6'} d={"M-800 1200 L-800 2000 L300 2000 "} fill={'#FF6184'} stroke={'none'} strokeWidth={'2'}/> */}
                            <path id={'backGround6'} d={"M1500 1800  A460 460 0 0 1 1290 1480   L1290 1480   A460 460 0 0 1  380 1400    L380 1320    L380 1320  A70 60  0 0 0  320 1250    L100 1250  A200 200  0 0 0  -100 1450   L-800 1450  L-800 1800  Q100 2400  800 2100  L800 2100  Q1200 1940  1500 2000  L1500 1800 "} fill={'#FF6184'} stroke={'none'} strokeWidth={'2'}/>

                            <path id={'backGround7'} d={" M900 1907   A540 490  0 0 1  320 1600     A165 165  0 0 0  0 1600     L-800 1600  L-800 1660  Q0 2340  900 2000        M900 2000  Q1200 1890  1450 1930  L1450 1820  Q1350 1750  1300 1650    L1280 1650  Q1150 1880  900 1907"} fill={'#FF9781'} stroke={'none'} strokeWidth={'2'}/>

                            <path id={'lightbulb3LightArr'} d={shapesArr[9][1]} fill={'#FFCD3A'} stroke={'none'} opacity={lightbulbOpacity/1.4} strokeWidth={'2'}/>
                            <path id={'lightbulbLightArr'} d={shapesArr[7][1]} fill={'#FFEC62'} stroke={'none'} opacity={lightbulbOpacity*0.94} strokeWidth={'2'}/>

                            {/* <defs>
                                <linearGradient id={"grad1"} x1={"0%"} y1={"0%"} x2={"0%"} y2={"100%"}>
                                    <stop offset={"0%"} style={{stopColor: '#F54D39', stopOpacity: '0.6'}} />
                                    <stop offset={"100%"} style={{stopColor: '#8F0B31', stopOpacity: '1'}} />
                                </linearGradient>
                            </defs>
                            <path id={'lightbulb4LightArr'} d={shapesArr[8][1]} fill={'url(#grad1)'} stroke={'none'} opacity={lightbulbOpacity} strokeWidth={'2'}/> */}

                            {/* <defs>
                                <radialGradient id={"grad2"} cx={"50%"} cy={"10%"} r={"90%"}>
                                    <stop offset={"0%"} style={{stopColor:'#FFECAA', stopOpacity:'0.6'}} />
                                    <stop offset={"100%"} style={{stopColor:'#FFECAA', stopOpacity: '0'}} />
                                </radialGradient>
                            </defs> */}
                            <path id={'lightbulb2LightArr'} d={shapesArr[8][1]} fill={'#FF626E'} stroke={'none'} opacity={lightbulbOpacity} strokeWidth={'2'}/>
                            



                            <path id={'filamentGlow'} d={shapesArr[3][1]} fill={'none'} stroke={'#FFFE98'} opacity={lightbulbOpacity} strokeWidth={'13'}/>
                            <path id={'filament'} d={shapesArr[3][1]} fill={'none'} stroke={'white'} strokeWidth={'4'}/>
        
                            <path id={'lightbulb'} d={shapesArr[2][1]} fill={'none'} stroke={'white'} strokeWidth={'7'}/>
                            {/* <path id={'highlights'} d={shapesArr[14][1]} fill={'#FFFEE1'} stroke={'#FFFEE1'} strokeWidth={'1'} opacity={'0.5'}/> */}
                            
                            <path d={shapesArr[1][1]} fill={'grey'} stroke={'grey'} strokeWidth={'2'}/>
                            <path d={shapesArr[0][1]} fill={'#5200D0'} stroke={'#5200D0'} strokeWidth={'2'}/>
                            <path d={shapesArr[4][1]} fill={'white'} stroke={'pink'} strokeWidth={'5'}/>
                            <path d={shapesArr[5][1]} fill={'black'} stroke={'black'} strokeWidth={'1'}/>
                            <path d={shapesArr[6][1]} fill={'red'} stroke={'pink'} strokeWidth={'5'}/>


                            
                            <Modal
                                className='modal'
                                isOpen={modalIsOpen}
                            >
                                <ModalContent project={modelContent} style={{margin: '0 auto'}}/>
                                <div onClick={() => handleClick('')} style={{cursor: 'pointer', color: 'purple', backgroundColor: "white", fontSize: '40', fontFamily: 'Montserrat Alternates, sans-serif', textDecoration: 'none', margin: '100px'}}>
                                    CLOSE
                                </div>
                            </Modal>

                            
                                <circle style={projectStyles} cx={centre1X} cy={centre1Y} r={radius1}/>
                                <circle onClick={() => handleClick('getLucky')} style={{cursor: 'pointer', fill: '#FFF9D4'}} cx={centre1X} cy={centre1Y} r={radius1*0.88}/>
                                <text onClick={() => handleClick('getLucky')} style={{cursor: 'pointer', fontFamily: 'Montserrat Alternates, sans-serif', fontSize: projectText}} x={centre1X - 120} y={centre1Y}>Get Lucky 3000</text>
                            

                            {/* <Link to="/getlucky3000">
                                <circle style={projectStyles} cx={centre1X} cy={centre1Y} r={radius1}/>
                                <circle style={{fill: '#FFF9D4'}} cx={centre1X} cy={centre1Y} r={radius1*0.88}/>
                                <text style={{fontFamily: 'Montserrat Alternates, sans-serif', fontSize: projectText}} x={centre1X - 120} y={centre1Y}>Get Lucky 3000</text>
                            </Link> */}






                                <circle style={projectStyles} cx={centre2X} cy={centre2Y} r={radius2}/>
                                <circle onClick={() => handleClick('garybuseylookalikes')} style={{cursor: 'pointer', fill: '#FFF9D4'}} cx={centre2X} cy={centre2Y} r={radius2*0.88}/>
                                <text onClick={() => handleClick('garybuseylookalikes')} style={{cursor: 'pointer', fontFamily: 'Montserrat Alternates, sans-serif', fontSize: projectText}} x={centre2X - 90} y={centre2Y - 30}>
                                    <tspan>Gary Busey</tspan>
                                    <tspan x={centre2X - 100} y={centre2Y + 20}> Look-A-Like</tspan>
                                    <tspan x={centre2X - 40} y={centre2Y + 70}> App</tspan>
                                </text>
              

                            {/* <Link to="/garybuseylookalikes">
                                <circle style={projectStyles} cx={centre2X} cy={centre2Y} r={radius2}/>
                                <circle style={{fill: '#FFF9D4'}} cx={centre2X} cy={centre2Y} r={radius2*0.88}/>
                                <text style={{fontFamily: 'Montserrat Alternates, sans-serif', fontSize: projectText}} x={centre2X - 90} y={centre2Y - 30}>
                                    <tspan>Gary Busey</tspan>
                                    <tspan x={centre2X - 100} y={centre2Y + 20}> Look-A-Like</tspan>
                                    <tspan x={centre2X - 40} y={centre2Y + 70}> App</tspan>
                                </text>
                            </Link> */}



                            





                                <circle style={projectStyles} cx={centre3X} cy={centre3Y} r={radius3}/>
                                <circle onClick={() => handleClick('musicterminalapp')} style={{cursor: 'pointer', fill: '#FFF9D4'}} cx={centre3X} cy={centre3Y} r={radius3*0.88}/>
                                <text onClick={() => handleClick('musicterminalapp')} style={{cursor: 'pointer', fontFamily: 'Montserrat Alternates, sans-serif', fontSize: projectText}} x={centre3X - 70} y={centre3Y - 30}>
                                    <tspan>Terminal</tspan>
                                    <tspan x={centre3X - 100} y={centre3Y + 20}>Music Editor</tspan>

                                </text>


                            {/* <Link to="/musicterminalapp">
                                <circle style={projectStyles} cx={centre3X} cy={centre3Y} r={radius3}/>
                                <circle style={{fill: '#FFF9D4'}} cx={centre3X} cy={centre3Y} r={radius3*0.88}/>
                                <text style={{fontFamily: 'Montserrat Alternates, sans-serif', fontSize: projectText}} x={centre3X - 70} y={centre3Y - 30}>
                                    <tspan>Terminal</tspan>
                                    <tspan x={centre3X - 100} y={centre3Y + 20}>Music Editor</tspan>

                                </text>
                            </Link> */}

 
                            {/* <circle onClick={animate} style={projectStyles} cx={txtX} cy={txtY} r={radius3}/> */}
                            <text onClick={animate} onMouseEnter={textOn} onMouseLeave={textOff} id="1" x={txtX} y={txtY} style={textStyles}>Projects</text>


                        </svg>
            </div>
        </div>
    )
}

export default Projects
